import { format } from "date-fns";
import { DateFormats } from "./formatters";

// Format date with time
export const formatDateTime = (dateString: string) => {
  if (!dateString) return 'N/A';

  try {
    let utcDate;

    if (dateString.includes('T')) {
      const isoString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
      utcDate = new Date(isoString);
    } else {
      utcDate = new Date(dateString + ' UTC');
    }

    if (isNaN(utcDate.getTime())) {
      return 'Invalid date';
    }

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return utcDate.toLocaleString('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

  } catch (error) {
    return 'N/A';
  }
};

export const formatDateTimeForInput = (dateString?: string | null): string => {
  if (!dateString) return "";

  const hasExplicitTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateString);
  const normalizedDateString = dateString.includes("T")
    ? hasExplicitTimezone
      ? dateString
      : `${dateString}Z`
    : `${dateString} UTC`;

  const date = new Date(normalizedDateString);
  if (isNaN(date.getTime())) return "";

  return format(date, DateFormats.dateTimeAt);
};

export const toUtcIsoDateTime = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return date.toISOString();
};


export const formatMonthYear = (dateString: string): string => {
  if (!dateString) return 'N/A';

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
    });

  } catch (error) {
    return 'N/A';
  }
};

export const formatDateForDisplay = (dateString?: string | null): string => {
  if (!dateString) return "";
  const hasExplicitTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateString);

  const normalizedDateString = dateString.includes("T")
    ? hasExplicitTimezone
      ? dateString
      : `${dateString}Z`
    : `${dateString} UTC`;

  const date = new Date(normalizedDateString);
  if (isNaN(date.getTime())) return "";

  return format(date, DateFormats.yearMonthDay);
};

export const dateFormatDynamic = (
  dateString?: string | null,
  formatString: string = DateFormats.monthDateYear,
  isUtc = false
): string => {
  if (!dateString) return "";

  let normalized = dateString.trim();

  normalized = normalized.replace(/\.(\d{3})\d+/, ".$1");

  if (isUtc && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    normalized += "Z";
  }

  const date = new Date(normalized);

  if (isNaN(date.getTime())) return "";

  return format(date, formatString);
};
